define( [
	"./class2type"
], function( class2type ) {
	return class2type.toString;
} );



// WEBPACK FOOTER //
// ./~/jquery/src/var/toString.js